import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32ebd44e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=32ebd44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ebd44e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ebd44e')) {
      api.createRecord('32ebd44e', component.options)
    } else {
      api.reload('32ebd44e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=32ebd44e&scoped=true&", function () {
      api.rerender('32ebd44e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/permission/index.vue"
export default component.exports